import { FeatureFlagState } from "~/modules/feature_flag/types";
import { SearchResultGroup } from "../types";

// // // //

/**
 * Removes feature-flagged SearchResultGroup + items if a user isn't allowed to view a search result
 */
export function removeFeatureFlaggedResults(props: {
    groups: SearchResultGroup[];
    featureFlagState: FeatureFlagState;
}): SearchResultGroup[] {
    const { groups, featureFlagState } = props;

    // Filter groups + nested items based on featureFlagState
    const filteredGroups = groups
        .map((group) => {
            // Check if group should be included based on feature flag
            const groupFeatureFlag = group.featureFlag;
            if (groupFeatureFlag) {
                const flagValue = featureFlagState[groupFeatureFlag];
                const shouldIncludeGroup = group.invertFeatureFlagBehavior
                    ? !flagValue
                    : flagValue;
                if (!shouldIncludeGroup) {
                    return null; // Exclude the entire group
                }
            }

            // Filter items in the group based on the feature flag state
            const filteredItems = group.items.filter((item) => {
                const featureFlag = item.featureFlag;
                if (featureFlag) {
                    const flagValue = featureFlagState[featureFlag];
                    return item.invertFeatureFlagBehavior
                        ? !flagValue
                        : flagValue;
                }
                return true; // If there's no feature flag specified, include the item
            });

            // Include the group only if there are filtered items
            if (filteredItems.length > 0) {
                return {
                    ...group,
                    items: filteredItems,
                };
            }

            return null; // Exclude the group if there are no filtered items
        })
        .filter(Boolean) as SearchResultGroup[];

    return filteredGroups;
}
